// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"555":"dd592111","887":"7da15242"}[chunkId] + ".chunk.js";
};